import { RealTimeDataStore } from "@app/services/store/real-time-data-store";
import { Type } from "@angular/core";
import { BaseEntity } from "@app/models/rest/base-entity";

export enum ChildEntityDeletionBehaviour {
  LINK_TABLE,
  RELATIONSHIP
}

export class ChildEntityModel<T extends BaseEntity, U extends BaseEntity> {
  type: Type<BaseEntity>;
  relation: string;
  display: string;
  title: string;
  addComponent: any;
  addWidth?: string;
  displayComponent: any;
  searchKey: string;
  store: RealTimeDataStore<T>;
  searchQuery: string;
  readonly: boolean;
  deletionBehaviour: ChildEntityDeletionBehaviour =
    ChildEntityDeletionBehaviour.LINK_TABLE;
  parentType: Type<BaseEntity> = null;
  parentStore: RealTimeDataStore<U> = null;
  parentRelation: string;
}
